import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosapi from "../utilities/axiosApi";

export const fetchAllCampaigns = createAsyncThunk("campaign/fetchAllCampaigns", async ({offset, limit, search,status},{ rejectWithValue }) => {
    try{
        const response = await axiosapi.get("api/admin/all-campaigns",{
            params:{offset, limit, search,status},
        });
        return response.data;
    }catch (err) {
        console.error("GET API Error:", err); 
        return rejectWithValue(err.response.data);  
    }
})





const campaignSlice = createSlice({
    name:"campaign",
    initialState:{
       allCampaigns:[],
       loader:false
    },
    reducers:{},
    extraReducers:(builder) => {
        builder
        .addCase(fetchAllCampaigns.pending, (state, action) => {
           state.loader = true;
        })
        .addCase(fetchAllCampaigns.fulfilled, (state, action) => {
            state.loader = false;
            state.allCampaigns = action.payload?.data || []
         })
         .addCase(fetchAllCampaigns.rejected, (state, action) => {
            state.loader = false;
         })

    }
})

export default campaignSlice.reducer;